module.exports = __webpack_public_path__ + "media/fans_cheering_1.218f3686.mp3";